import React, { useContext, useEffect, useRef, useState } from 'react';
import GeneralSearch from '../../../../../components/Search/Merchandising/WooCommerce/GeneralSearch';
import BuriedProducts from '../../../../../components/Search/Merchandising/WooCommerce/BuriedProducts';
import SidebarNavigation from '../../../../../components/Search/Merchandising/WooCommerce/SidebarNavigation';
import ProductListing from '../../../../../components/Search/Merchandising/WooCommerce/ProductListing';
import Banners from '../../../../../components/Search/Merchandising/WooCommerce/Banners';
import PromoTiles from '../../../../../components/Search/Merchandising/WooCommerce/PromoTiles';
import HiddenProducts from '../../../../../components/Search/Merchandising/WooCommerce/HiddenProducts';
import Dynamic from '../../../../../components/Search/Merchandising/WooCommerce/Dynamic';

import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ProductContext } from '../../../../../store';
import {
	DndContext,
	DragOverlay,
	closestCenter,
	KeyboardSensor,
	PointerSensor,
	useSensor,
	useSensors,
	TouchSensor,
	MouseSensor
} from "@dnd-kit/core";
import {
	// SortableContext,
	// verticalListSortingStrategy,
	arrayMove,
	sortableKeyboardCoordinates,
} from "@dnd-kit/sortable";
import { PostData } from '../../../../../services/FetchData';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faExclamationCircle, faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import DetailSkeleton from '../../../../../components/Skeleton/DetailSkeleton';

const EditSearch = () => {
	const [pageLoader, setPageLoader] = useState(false),
		[initalLoadFlag, setInitalLoadFlag] = useState(true),
		navigate = useNavigate(),
		location = useLocation(),
		[state, setState] = useState(location.state || "{}"),
		timerRef = useRef(null),
		{
			activeMenu,
			searchPhrase,
			description,
			setProductLoader,
			productPage,
			setProductPage,
			enableSave,
			setEnableSave,
			products,
			setProducts,
			hidden,
			buried,
			promoted,
			setSearchPhrase,
			setPagePerProducts,
			setProductCount,
			setRowPerProducts,
			setShopCurrency,
			setHasMore,
			productOrder,
			setProductOrder,
			saveLoader,
			setSaveLoader,
			setBuried,
			shopCurrency,
			setHidden,
			setPromoted,
			buriedProducts,
			productCount,
			setBuriedProducts,
			hiddenProducts,
			setHiddenProducts,
			setExact,
			setActiveMenu,
			activeItem,
			setActiveItem,
			setEditSearchPhraseMerchandising,
			exact,
			editSearchPhraseMerchandising,
			setDescription,
			setLoadVisualEditor,
			channelId,
			debouncedSearch,
			setDebouncedSearch,
			setMerchandisingError,
			setChannelId,
			setOriginalProducts,
			hiddenProductIndex,
			pinnedProductIndex,
			setPinnedItems,
			setHiddenProductIndex,
			setPinnedProductIndex,
			originalProductOrder,
			pinnedItems,
			originalProducts,
			setOriginalProductOrder,
			setBanners,
			selectedBanner,
			setSelectedBanner,
			setBannerLoader,
			setPromoTileLoader,
			setPromoTiles,
			selectedPromoTiles,
			setSelectedPromoTiles,
			enableDynamic,
			setEnableDynamic,
			dynamicItems,
			setDynamicItems,
			triggerDynamic,
			setTriggerDynamic,
			currentWebsiteId
		} = useContext(ProductContext),
		[dropdownOpen, setDropdownOpen] = useState(false),
		toggleDropdown = () => setDropdownOpen((prev) => !prev),
		pointerSensor = useSensor(PointerSensor, {
			activationConstraint: {
				distance: 0.01
			}
		}),
		items = [
			{ content: "2 Products", value: 2 },
			{ content: "3 Products", value: 3 },
			{ content: "4 Products", value: 4 },
			{ content: "5 Products", value: 5 },
			{ content: "6 Products", value: 6 },
		],
		sensors = useSensors(
			pointerSensor,
			useSensor(TouchSensor),
			useSensor(MouseSensor),
			useSensor(KeyboardSensor, {
				coordinateGetter: sortableKeyboardCoordinates,
			})
		)
	useEffect(() => {
		setLoadVisualEditor(true)
		if( !currentWebsiteId ) return
		if (state.type === "new") {
			getShopCurrency()
		} else if (state.type === "edit") {
			getSearchMerchandising(state.searchMerchandisingId)
			getShopCurrency()
		} else {
			navigate("/search/merchandising/search");
		}
		return () => {
			setProducts([])
			setActiveMenu('general')
			setLoadVisualEditor(false)
			setSearchPhrase(null)
			setExact(true)
			setDescription("")
			setDebouncedSearch(null)
			setProductPage(1)
			setEnableSave(false)
			setBuried([])
			setHidden([])
			setPromoted([])
			setBuriedProducts([])
			setHiddenProducts([])
			setOriginalProducts([])
			setPinnedItems({})
			setPinnedProductIndex({})
			setHiddenProductIndex({})
			setBanners([])
			setSelectedBanner({})
			setBannerLoader(false)
			setSaveLoader(false)
			setSelectedPromoTiles({})
			setPromoTiles([])
			setPromoTileLoader(false)
		}
	}, [state, currentWebsiteId])

	useEffect(() => {
		const idIndexMapLocal = new Map();
		products.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
		setProductOrder(idIndexMapLocal)
	}, [products])

	useEffect(() => {
		const idIndexMapLocal = new Map();
		originalProducts.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
		setOriginalProductOrder(idIndexMapLocal)
		if (state.type === "edit") {
			let pinnedProductIndexLocal = { ...pinnedProductIndex },
				hiddenProductIndexLocal = { ...hiddenProductIndex },
				pinnedItemKeys = Object.keys(pinnedItems)
			if (hidden.length > 0) {
				for (let i = 0; i < hidden.length; i++) {
					let currentProductId = hidden[i]
					if (typeof hiddenProductIndexLocal[currentProductId] === "undefined" && idIndexMapLocal.get(currentProductId)) {
						hiddenProductIndexLocal[currentProductId] = idIndexMapLocal.get(currentProductId)
					}
				}
			}
			if (pinnedItemKeys.length > 0) {
				for (let i = 0; i < pinnedItemKeys.length; i++) {
					let currentProductId = pinnedItemKeys[i]
					if (typeof pinnedProductIndexLocal[currentProductId] === "undefined" && idIndexMapLocal.get(currentProductId)) {
						pinnedProductIndexLocal[currentProductId] = idIndexMapLocal.get(currentProductId)
					}
				}
			}
			setPinnedProductIndex(pinnedProductIndexLocal)
			setHiddenProductIndex(hiddenProductIndexLocal)
		}
	}, [originalProducts])

	// Debounce the query input
	useEffect(() => {
		if (searchPhrase) {
			timerRef.current = setTimeout(() => {
				setDebouncedSearch(searchPhrase);
			}, 2000); // 500ms delay

		} else {
			if (!initalLoadFlag) {
				setEnableSave(false)
				setProducts([])
				setBuried([])
				setHidden([])
				setPromoted([])
				setBuriedProducts([])
				setHiddenProducts([])
				setOriginalProducts([])
				setPinnedItems({})
				setPinnedProductIndex({})
				setHiddenProductIndex({})
				setSelectedPromoTiles({})
				setDebouncedSearch("")
			}
		}
		return () => {
			if (timerRef.current) {
				clearTimeout(timerRef.current); // Cleanup on unmount or query change
			}
		}
	}, [searchPhrase]);

	useEffect(() => {
		if (debouncedSearch) {
			getSearchPhraseProducts()
		} else {
			if (!initalLoadFlag) {
				setEnableSave(false)
				setProducts([])
				setBuried([])
				setHidden([])
				setPromoted([])
				setBuriedProducts([])
				setHiddenProducts([])
				setSelectedPromoTiles({})
				setOriginalProducts([])
			}
		}
	}, [debouncedSearch, productPage, channelId])

	useEffect(() => {
		if (currentWebsiteId) {
			getBanners()
			getPromoTiles()
		}
	}, [currentWebsiteId])

	useEffect(() => {
		if (triggerDynamic) {
			setTriggerDynamic(false)
			saveSearchMerchandising()
		}
	}, [triggerDynamic])

	useEffect(() => {
		if (Object.keys(dynamicItems).length > 0) {
			setEnableDynamic(true)
		} else {
			setEnableDynamic(false)
		}
	}, [dynamicItems])

	const getBanners = async () => {
		setBannerLoader(true)
		PostData("ms3", "api/v1/woocommerce/getAllBanners", { websiteId: currentWebsiteId }).then(response => {
			if (response !== "Invalid" && response !== undefined) {
				if (response.status === "success") {
					setBanners(response.data.banners)
				}
			}
			setBannerLoader(false)
		})
	}

	const getPromoTiles = async () => {
		setPromoTileLoader(true)
		PostData("ms3", "api/v1/woocommerce/getAllPromoTiles", { websiteId: currentWebsiteId }).then(response => {
			if (response !== "Invalid" && response !== undefined) {
				if (response.status === "success") {
					setPromoTiles(response.data.promoTiles)
				}
			}
			setPromoTileLoader(false)
		})
	}

	const getSearchPhraseProducts = async (loadPage = null) => {
		let page = loadPage ?? productPage
		if (loadPage) {
			setProductPage(1)
		}
		setProductLoader(true)
		PostData("ms3", "api/v1/woocommerce/getSearchPhraseProducts", { searchPhrase: debouncedSearch, type: state.type, exact, page, channelId, websiteId: currentWebsiteId }).then((response) => {
			if (response !== "Invalid" && response !== undefined) {
				if (response.status === "success") {
					setMerchandisingError("")
					setProducts((prev) => [...prev, ...response.data.products])
					setOriginalProducts((prev) => [...prev, ...response.data.noCuratedProducts])
					setProductCount(response.data.totalProducts)
					setPagePerProducts(response.data.pagePerProducts)
					setInitalLoadFlag(false)
					if (productPage * (response.data.pagePerProducts * 3) < response.data.totalProducts) {
						setHasMore(true)
						setProductPage((prev) => prev + 1)
					} else {
						setEnableSave(true)
						setHasMore(false)
					}
				} else {
					setMerchandisingError(response.message)
					setProducts([])
					setBuried([])
					setBuriedProducts([])
					setPromoted([])
					setHidden([])
					setOriginalProducts([])
					setHiddenProducts([])
					setPinnedItems({})
					setPinnedProductIndex({})
					setHiddenProductIndex({})
					setDebouncedSearch("")
				}
			}
			setProductLoader(false)
		})
	}

	const getSearchMerchandising = async (searchMerchandisingId) => {
		setPageLoader(true)
		PostData("ms3", "api/v1/woocommerce/getSearchMerchandising", { searchMerchandisingId, websiteId: currentWebsiteId }).then(response => {
			if (response !== "Invalid" && response !== undefined) {
				if (response.status === "success") {
					let searchMerchandising = response.data.searchMerchandising
					setEditSearchPhraseMerchandising(searchMerchandising)
					setPinnedItems(searchMerchandising.pinnedItems)
					setBuried(searchMerchandising.buriedIds)
					setPromoted(searchMerchandising.promotedIds)
					setHidden(searchMerchandising.hiddenIds)
					setBuriedProducts(response.data.buriedProducts)
					setHiddenProducts(response.data.hiddenProducts)
					setSearchPhrase(searchMerchandising.searchPhrase)
					setExact(searchMerchandising.exact)
					setDescription(searchMerchandising.description)
					setChannelId(searchMerchandising.channelId)
					setSelectedPromoTiles(searchMerchandising.promoTiles ?? {})
					setDynamicItems(searchMerchandising.dynamicItems ?? {})
					setEnableSave(false)
					setSelectedBanner(response.data.banner ?? {})
				} else if (response.status === "failure") {
					navigate("/search/merchandising/search");
				}
			}
			setPageLoader(false)
		})
	}

	const saveSearchMerchandising = async () => {
		setSaveLoader(true)
		let data = { hidden, buried, promoted, searchPhrase, description, exact, productCount, channelId: parseInt(channelId), pinnedItems, banner: selectedBanner, promoTiles: selectedPromoTiles, enableDynamic, dynamicItems, websiteId: currentWebsiteId },
			url = `api/v1/woocommerce/createSearchMerchandising`
		if (state.type === "edit") {
			url = `api/v1/woocommerce/editSearchMerchandising`
			data["searchMerchandisingId"] = editSearchPhraseMerchandising.searchMerchandisingId
		}
		PostData("ms3", url, data).then(async (response) => {
			if (response !== "Invalid" && response !== undefined) {
				if (response.status === "success") {
					toast.success(response.message)
					if (state.type === "new") {
						setState({ type: "edit", searchMerchandisingId: response.data.searchMerchandising.searchMerchandisingId })
					} else if (dynamicItems && ((Object.keys(dynamicItems).length > 0 && !enableDynamic) || Object.keys(dynamicItems).length === 0 && enableDynamic)) {
						await getSearchMerchandising(state.searchMerchandisingId)
						// setProducts([])
						// setProductPage(null)
						// setProductPage(1)
						getSearchPhraseProducts(1)
					}
				} else if (response.status === "failure") {
					toast.error(response.message)
				}
			}
			setSaveLoader(false)
		})
	}

	const getShopCurrency = async () => {
		PostData("ms3", "api/v1/woocommerce/getShopCurrency", { websiteId: currentWebsiteId }).then(response => {
			if (response !== "Invalid" && response !== undefined) {
				if (response.status === "success") {
					setShopCurrency(response.data.shopCurrency)
				}
			}
		})
	}

	const goBack = () => {
		navigate("/search/merchandising/search");
	}

	const getPriceRange = (product) => {
		let min = product.price,
			max = product.price;
		if (typeof product.variants !== "undefined" && product.variants.length > 0) {
			min = product.variants[0].calculated_price > 0 ? product.variants[0].calculated_price : (product.variants[0].sale_price > 0 ? product.variants[0].sale_price : product.variants[0].price)
			max = min
			for (let i = 0; i < product.variants.length; i++) {
				let currentVariant = product.variants[i]
				if (currentVariant.calculated_price > 0) {
					if (min > currentVariant.calculated_price) {
						min = currentVariant.calculated_price
					} else if (max < currentVariant.calculated_price) {
						max = currentVariant.calculated_price
					}
				} else if (currentVariant.sale_price > 0) {
					if (min > currentVariant.sale_price) {
						min = currentVariant.sale_price
					} else if (max < currentVariant.sale_price) {
						max = currentVariant.sale_price
					}
				} else if (currentVariant.price > 0) {
					if (min > currentVariant.price) {
						min = currentVariant.price
					} else if (max < currentVariant.price) {
						max = currentVariant.price
					}
				}
			}
		}
		return { min, max }
	}

	const formPriceText = (price) => {
		let priceAmt = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: shopCurrency,
		}).format(price);
		return priceAmt
	}

	const formatPrice = (product) => {
		let { min, max } = getPriceRange(product)
		if (min === max) {
			if (product.sale_price > 0) {
				return <><span className="cbPriceList">{formPriceText(product.sale_price)}</span><span className="cbPriceList cbOriginalPrice">{formPriceText(product.price)}</span></>
			} else {
				return <span className="cbPriceList">{formPriceText(product.price)}</span>
			}
		} else {
			let minPrice = formPriceText(min),
				maxPrice = formPriceText(max);
			return <span className="cbPriceList">{minPrice} - {maxPrice}</span>
		}
	}

	const handleDragStart = (event) => {
		// Check if drag was initiated by keyboard
		if (event.activatorEvent instanceof KeyboardEvent) {
			console.log('Keyboard drag prevented');
			return; // Stop execution here - don't set active item
		}
		setActiveItem(event.active.id);
	}

	const handleDragEnd = (event) => {
		const { active, over } = event;
		setActiveItem(null);
		if (!over || active.id.id === over.id.id) return;
		let productId = active.id.id,
			newIndexProductId = over.id.id,
			productIndex = productOrder.get(productId) ?? -1,
			newIndex = productOrder.get(over.id.id),
			overProductId = over.id.id,
			productsLocal = [...products],
			dynamicItemsLocal = { ...dynamicItems },
			selectedPromoTilesLocal = { ...selectedPromoTiles },
			newElementFlag = false,
			element = ( productIndex >= 0 && typeof active.id.promoTileId === "undefined" ) ? productsLocal.splice(productIndex, 1)[0] : {}
		if( !dynamicItemsLocal || ( dynamicItemsLocal && Object.keys(dynamicItemsLocal).length === 0 ) ){
			let promotedLocal = [...promoted],
				originalProductIndex = originalProductOrder.get(productId),
				pinnedItemsLocal = { ...pinnedItems },
				pinnedProductIndexLocal = { ...pinnedProductIndex },
				buriedLocal = [...buried],
				buriedProductsLocal = [...buriedProducts],
				pinnedWIthPromoted = {...pinnedItemsLocal, ...selectedPromoTilesLocal},
				promotedPinned	= {},
				buriedPinned	= {},
				onlyPinnedItemsLocal =  {},
				onlyPinnedValueItems = {},
				pinnedPositions = [],
				pPPPosition = typeof pinnedItemsLocal[productId] !== "undefined" ? pinnedItemsLocal[productId] : null,
				buriedPosition = productsLocal.length;
			Object.keys(pinnedWIthPromoted).forEach((item) => {
				if( promotedLocal.indexOf(item) !== -1 ){
					promotedPinned[item] = pinnedWIthPromoted[item]
				}else if( buriedLocal.indexOf(item) !== -1 ){
					buriedPinned[item] = pinnedWIthPromoted[item]
				}else{
					onlyPinnedItemsLocal[item] = pinnedWIthPromoted[item]
					if( typeof pinnedItemsLocal[item] !== "undefined" ){
						onlyPinnedValueItems[item] = pinnedItemsLocal[item]
					}
				}
			})
			pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
			if( active.id.isBanner ){
				if( typeof active.id.promoTileId !== "undefined" ){
					let suffix = '',
						newProductId = active.id.id;
					while (selectedPromoTilesLocal.hasOwnProperty(newProductId)) {
						suffix += '#';
						newProductId = active.id.id + suffix;
					}
					productId = newProductId					
					element = active.id
					element = {
						...element,
						id: productId
					}
					delete element.promoTileId;
					newElementFlag = true;
				}
				selectedPromoTilesLocal[productId] = newIndex
			}
			if( hidden.indexOf(productId) !== -1 ){
				let hiddenLocal = [...hidden],
					hiddenProductsLocal = [...hiddenProducts]
				let hiddenIndex = hiddenLocal.indexOf(productId)
				element = hiddenProductsLocal[hiddenIndex]
				hiddenLocal.splice(hiddenIndex, 1)
				hiddenProductsLocal.splice(hiddenIndex, 1)
				setHidden(hiddenLocal)
				setHiddenProducts(hiddenProductsLocal)
				newElementFlag = true;
				if( buriedLocal.indexOf(overProductId) !== -1 ){
					buriedLocal.push(productId)
					buriedProductsLocal.push(element)
					let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
						currentPosition = sortedKeyArray.indexOf(overProductId)
					for( let i = currentPosition; i < sortedKeyArray.length; i++ ){
						if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
							let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
						}
					}
				}else{
					let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					for( let i = 0; i < sortedKeyArray.length; i++ ){
						let currentProductId = sortedKeyArray[i],
							currentProductPosition = buriedPinned[currentProductId]
						if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" && currentProductPosition > newIndex   ){
							let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
						}
					}
					if( promotedLocal.indexOf(overProductId) !== -1 ){
						promotedLocal.push(productId)
						let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentPosition = sortedKeyArray.indexOf(overProductId)
						for( let i = currentPosition; i < sortedKeyArray.length; i++ ){
							if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
								let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
							}
						}
					}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
						let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItems = sortedKeyArray.indexOf(overProductId)
						for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
							let currentProductId = sortedKeyArray[i],
								updateCurrentPosition = 0;
							if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
								updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
								selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
							}else{
								updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
								pinnedItemsLocal[currentProductId] = updateCurrentPosition
							}
							if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
								break;
							}
						}
					}
				}
				pinnedItemsLocal[productId] = newIndex

			}else if( onlyPinnedValueItems.hasOwnProperty(productId) ){				
				let currentPosition = onlyPinnedValueItems[productId]
				let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
				delete onlyPinnedItemsLocal[productId]
				pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
				for( let i = 0; i < sortedKeyArray.length; i++ ){
					let currentProductId = sortedKeyArray[i],
						currentProductPosition = pinnedItemsLocal[currentProductId]
					if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
						let newChangePosition = pinnedItemsLocal[currentProductId] - 1
						while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
							newChangePosition = newChangePosition - 1
						}
						pinnedItemsLocal[currentProductId] = newChangePosition
					}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
						let newChangePosition = pinnedItemsLocal[currentProductId] + 1
						while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
							newChangePosition = newChangePosition + 1
						}
						pinnedItemsLocal[currentProductId] = newChangePosition
					}
				}
				let sortedBuriedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
				for( let i = 0; i < sortedBuriedKeyArray.length; i++ ){
					let currentProductId = sortedBuriedKeyArray[i],
						currentProductPosition = pinnedItemsLocal[currentProductId]
					if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
						let newChangePosition = pinnedItemsLocal[currentProductId] - 1
						while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
							newChangePosition = newChangePosition - 1
						}
						pinnedItemsLocal[currentProductId] = newChangePosition
					}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
						let newChangePosition = pinnedItemsLocal[currentProductId] + 1
						while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
							newChangePosition = newChangePosition + 1
						}
						pinnedItemsLocal[currentProductId] = newChangePosition
					}
				}
				if( promotedLocal.indexOf(overProductId) !== -1 ){
					promotedLocal.push(productId)						
				}else if( buriedLocal.indexOf(overProductId) !== -1 ){
					buriedLocal.push(productId)
					buriedProductsLocal.push(element)
				}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
					let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
						currentOnlyPinItems = sortedKeyArray.indexOf(overProductId),
						sortedWithBuried = Object.entries({...onlyPinnedItemsLocal, ...buriedPinned}).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
						currentOnlyPinItemsWithBuried = sortedWithBuried.indexOf(overProductId),
						remainingItems = sortedWithBuried.length - currentOnlyPinItemsWithBuried;
					if( productsLocal.length > onlyPinnedItemsLocal[sortedKeyArray[currentOnlyPinItems]] + remainingItems ){
						for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
							let currentProductId = sortedKeyArray[i],
								updateCurrentPosition = 0;
							if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
								updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
								selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
							}else{
								updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
								pinnedItemsLocal[currentProductId] = updateCurrentPosition
							}
							if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
								break;
							}
						}
					}else{
						for( let i = currentOnlyPinItems; i >= 0; i-- ){
							let currentProductId = sortedKeyArray[i],
								updateCurrentPosition = 0;
							if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
								updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
								selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
							}else{
								updateCurrentPosition = pinnedItemsLocal[currentProductId] - 1
								pinnedItemsLocal[currentProductId] = updateCurrentPosition
							}
							if( typeof onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== updateCurrentPosition ){
								break;
							}
						}
					}
				}
				pinnedItemsLocal[productId] = newIndex
			}else if( promotedLocal.indexOf(productId) !== -1 ){
				if( promotedLocal.indexOf(overProductId) !== -1 ){
					let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
						currentPosition = sortedKeyArray.indexOf(productId),
						finalCurrentPosition = sortedKeyArray.indexOf(overProductId)
					if( currentPosition > finalCurrentPosition ){
						for( let i = finalCurrentPosition; i < currentPosition; i++ ){
							if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
								let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
							}
						}
					}else{
						for( let i = currentPosition+1; i <= finalCurrentPosition; i++ ){
							if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
								let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition - 1
								}
								pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
							}
						}
					}
				}else {
					let currentPromotedPosition = promotedLocal.indexOf(productId)
					promotedLocal.splice(currentPromotedPosition, 1)
					let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
						currentPosition = sortedKeyArray.indexOf(productId)
					for( let i = 0; i < sortedKeyArray.length; i++ ){
						if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
							let currentProductPosition = pinnedItemsLocal[sortedKeyArray[i]]
							if( productIndex < newIndex && productIndex <= currentProductPosition ){
								let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition - 1
								}
								pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
							}else if(newIndex < productIndex && currentProductPosition > newIndex && currentProductPosition <= productIndex){
								let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
							}
						}
					}
					if( buriedLocal.indexOf(overProductId) !== -1 ){
						buriedLocal.push(productId)
						buriedProductsLocal.push(element)
						let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentPosition = sortedKeyArray.indexOf(overProductId)
						for( let i = 0; i < currentPosition+1; i++ ){
							let currentProductId = sortedKeyArray[i]
							if( typeof pinnedItemsLocal[currentProductId] !== "undefined" ){
								let newChangePosition = pinnedItemsLocal[currentProductId] - 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition - 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}
						}
					}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
						let sortedBuriedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
						for( let i = 0; i < sortedBuriedKeyArray.length; i++ ){
							let currentProductId = sortedBuriedKeyArray[i],
								currentProductPosition = pinnedItemsLocal[currentProductId]
							if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
								let newChangePosition = pinnedItemsLocal[currentProductId] - 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition - 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}
						}
						let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItems = sortedKeyArray.indexOf(overProductId),
							sortedWithBuried = Object.entries({...onlyPinnedItemsLocal, ...buriedPinned}).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItemsWithBuried = sortedWithBuried.indexOf(overProductId),
							remainingItems = sortedWithBuried.length - currentOnlyPinItemsWithBuried;
						if( productsLocal.length > onlyPinnedItemsLocal[sortedKeyArray[currentOnlyPinItems]] + remainingItems ){
							for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
									break;
								}
							}
						}else{
							for( let i = currentOnlyPinItems; i >= 0; i-- ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] - 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== updateCurrentPosition ){
									break;
								}
							}
						}
					}
				}
				pinnedItemsLocal[productId] = newIndex
			}else if( buriedLocal.indexOf(productId) !== -1 ){
				if( buriedLocal.indexOf(overProductId) !== -1 ){
					let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
						currentPosition = sortedKeyArray.indexOf(productId),
						finalCurrentPosition = sortedKeyArray.indexOf(overProductId)
					if( currentPosition > finalCurrentPosition ){
						for( let i = finalCurrentPosition; i < currentPosition; i++ ){
							if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
								let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
							}
						}
					}else{
						for( let i = currentPosition+1; i <= finalCurrentPosition; i++ ){
							if( typeof pinnedItemsLocal[sortedKeyArray[i]] !== "undefined" ){
								let newChangePosition = pinnedItemsLocal[sortedKeyArray[i]] - 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition - 1
								}
								pinnedItemsLocal[sortedKeyArray[i]] = newChangePosition
							}
						}
					}
				}else{
					let currentBuriedPosition = buriedLocal.indexOf(productId)
					buriedLocal.splice(currentBuriedPosition, 1)
					buriedProductsLocal.splice(currentBuriedPosition, 1)
					let sortedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
						currentPosition = sortedKeyArray.indexOf(productId)

					for( let i = currentPosition; i >= 0; i-- ){
						let currentProductId = sortedKeyArray[i]
						if( typeof pinnedItemsLocal[currentProductId] !== "undefined" && pinnedItemsLocal[currentProductId] > newIndex ){
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					if( promotedLocal.indexOf(overProductId) !== -1 ){
						promotedLocal.push(productId)
						let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentPosition = sortedKeyArray.indexOf(overProductId)
						for( let i = currentPosition; i < sortedKeyArray.length; i++ ){
							let currentProductId = sortedKeyArray[i]
							if( typeof pinnedItemsLocal[currentProductId] !== "undefined" ){
								let newChangePosition = pinnedItemsLocal[currentProductId] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}
						}
					}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
						let sortedPromotedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
						for( let i = 0; i < sortedPromotedKeyArray.length; i++ ){
							let currentProductId = sortedPromotedKeyArray[i],
								currentProductPosition = pinnedItemsLocal[currentProductId]
							if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
								let newChangePosition = pinnedItemsLocal[currentProductId] + 1
								while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
									newChangePosition = newChangePosition + 1
								}
								pinnedItemsLocal[currentProductId] = newChangePosition
							}
						}
						let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItems = sortedKeyArray.indexOf(overProductId)
						for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
							let currentProductId = sortedKeyArray[i],
								updateCurrentPosition = 0;
							if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
								updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
								selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
							}else{
								updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
								pinnedItemsLocal[currentProductId] = updateCurrentPosition
							}
							if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
								break;
							}
						}
					}
				}
				pinnedItemsLocal[productId] = newIndex
			}else if( selectedPromoTilesLocal.hasOwnProperty(productId) ){
				if( typeof active.id.promoTileId !== "undefined" ){
					let promotedPinnedPosition = Object.values(promotedPinned).sort((a, b) => Number(a) - Number(b)),
						sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					for( let i = 0; i < promotedPinnedPosition.length; i++ ){
						if( newIndex <= promotedPinnedPosition[i] ){
							let currentProductId = sortedKeyArray[i]
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					let buriedPinnedPosition = Object.values(buriedPinned).sort((a, b) => Number(a) - Number(b)),
						sortedBuriedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					for( let i = 0; i < buriedPinnedPosition.length; i++ ){
						if( newIndex <= buriedPinnedPosition[i] ){
							let currentProductId = sortedBuriedKeyArray[i]
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
						let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItems = sortedKeyArray.indexOf(overProductId)
						for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
							console.log(currentOnlyPinItems, "currentOnlyPinItems")
							console.log(sortedKeyArray, "sortedKeyArray")
							console.log(sortedKeyArray[i], "sortedKeyArray[i]")
							let currentProductId = sortedKeyArray[i],
								updateCurrentPosition = 0;
							if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
								updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
								selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
							}else{
								updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
								pinnedItemsLocal[currentProductId] = updateCurrentPosition
							}
							if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
								break;
							}
						}
					}
				}else{
					let currentPosition = onlyPinnedItemsLocal[productId]
					let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					delete onlyPinnedItemsLocal[productId]
					pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
					for( let i = 0; i < sortedKeyArray.length; i++ ){
						let currentProductId = sortedKeyArray[i],
							currentProductPosition = pinnedItemsLocal[currentProductId]
						if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
							let newChangePosition = pinnedItemsLocal[currentProductId] - 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition - 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					let sortedBuriedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					for( let i = 0; i < sortedBuriedKeyArray.length; i++ ){
						let currentProductId = sortedBuriedKeyArray[i],
							currentProductPosition = pinnedItemsLocal[currentProductId]
						if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
							let newChangePosition = pinnedItemsLocal[currentProductId] - 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition - 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
						let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItems = sortedKeyArray.indexOf(overProductId),
							sortedWithBuried = Object.entries({...onlyPinnedItemsLocal, ...buriedPinned}).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItemsWithBuried = sortedWithBuried.indexOf(overProductId),
							remainingItems = sortedWithBuried.length - currentOnlyPinItemsWithBuried;
						if( productsLocal.length > onlyPinnedItemsLocal[sortedKeyArray[currentOnlyPinItems]] + remainingItems ){
							for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
									break;
								}
							}
						}else{
							for( let i = currentOnlyPinItems; i >= 0; i-- ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] - 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== updateCurrentPosition ){
									break;
								}
							}
						}
					}
				}
			}else if( !pinnedWIthPromoted.hasOwnProperty(productId) ){
				if( !pinnedWIthPromoted.hasOwnProperty(overProductId) ){
					pinnedItemsLocal[productId] = newIndex
				}else{
					let currentPosition = productOrder.get(productId)
					let sortedKeyArray = Object.entries(promotedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					pinnedPositions = Object.values(onlyPinnedItemsLocal).sort((a, b) => Number(a) - Number(b))
					for( let i = 0; i < sortedKeyArray.length; i++ ){
						let currentProductId = sortedKeyArray[i],
							currentProductPosition = pinnedItemsLocal[currentProductId]
						if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
							let newChangePosition = pinnedItemsLocal[currentProductId] - 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition - 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					let sortedBuriedKeyArray = Object.entries(buriedPinned).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
					for( let i = 0; i < sortedBuriedKeyArray.length; i++ ){
						let currentProductId = sortedBuriedKeyArray[i],
							currentProductPosition = pinnedItemsLocal[currentProductId]
						if( currentPosition < currentProductPosition && currentProductPosition <= newIndex ){
							let newChangePosition = pinnedItemsLocal[currentProductId] - 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition - 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}else if( newIndex <= currentProductPosition && currentProductPosition < currentPosition ){
							let newChangePosition = pinnedItemsLocal[currentProductId] + 1
							while( pinnedPositions.indexOf(newChangePosition) !== -1 ){
								newChangePosition = newChangePosition + 1
							}
							pinnedItemsLocal[currentProductId] = newChangePosition
						}
					}
					if( promotedLocal.indexOf(overProductId) !== -1 ){
						promotedLocal.push(productId)						
					}else if( buriedLocal.indexOf(overProductId) !== -1 ){
						buriedLocal.push(productId)
						buriedProductsLocal.push(element)
					}else if( onlyPinnedItemsLocal.hasOwnProperty(overProductId) ){
						let sortedKeyArray = Object.entries(onlyPinnedItemsLocal).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItems = sortedKeyArray.indexOf(overProductId),
							sortedWithBuried = Object.entries({...onlyPinnedItemsLocal, ...buriedPinned}).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
							currentOnlyPinItemsWithBuried = sortedWithBuried.indexOf(overProductId),
							remainingItems = sortedWithBuried.length - currentOnlyPinItemsWithBuried;
						if( productsLocal.length > onlyPinnedItemsLocal[sortedKeyArray[currentOnlyPinItems]] + remainingItems ){
							for( let i = currentOnlyPinItems; i < sortedKeyArray.length; i++ ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] + 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i+1]] !== updateCurrentPosition ){
									break;
								}
							}
						}else{
							for( let i = currentOnlyPinItems; i >= 0; i-- ){
								let currentProductId = sortedKeyArray[i],
									updateCurrentPosition = 0;
								if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
									updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
									selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
								}else{
									updateCurrentPosition = pinnedItemsLocal[currentProductId] - 1
									pinnedItemsLocal[currentProductId] = updateCurrentPosition
								}
								if( typeof onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== "undefined" && onlyPinnedItemsLocal[sortedKeyArray[i-1]] !== updateCurrentPosition ){
									break;
								}
							}
						}
					}
					pinnedItemsLocal[productId] = newIndex
				}
			}
			productsLocal.splice(newIndex, 0, element)
			let positionIds = { ...pinnedItemsLocal, ...selectedPromoTilesLocal, ...dynamicItemsLocal },
				pinnedProductIds = Object.entries(positionIds).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key)
			if (pinnedProductIds.length > 0) {
				const idIndexMapLocal = new Map();
				let elements = []
				productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index));
				for( let i = 0; i < pinnedProductIds.length; i++ ){
					let currentProductId = pinnedProductIds[i]
					let productIndex = idIndexMapLocal.get(currentProductId)
					let element = productsLocal.splice(productIndex, 1)[0]
					productsLocal.forEach((obj, index) => idIndexMapLocal.set(obj.id, index))
					elements.push(element)
				}
				for( let i = 0; i < pinnedProductIds.length; i++ ){
					let element = elements[i]
					let currentProductId = pinnedProductIds[i]
					productsLocal.splice(positionIds[currentProductId], 0, element)
				}
			}
			setPromoted(promotedLocal)
			setBuriedProducts(buriedProductsLocal)
			setBuried(buriedLocal)
			setSelectedPromoTiles(selectedPromoTilesLocal)
			setPinnedItems(pinnedItemsLocal)
			setPinnedProductIndex(pinnedProductIndexLocal)
			setDynamicItems(dynamicItemsLocal)
			setProducts(productsLocal)
		}else{
			let dynamicWithPromoted = {...dynamicItemsLocal, ...selectedPromoTilesLocal}
			if( active.id.isBanner ){
				if( typeof active.id.promoTileId !== "undefined" ){
					let suffix = '',
						newProductId = active.id.id;
					while (selectedPromoTilesLocal.hasOwnProperty(newProductId)) {
						suffix += '#';
						newProductId = active.id.id + suffix;
					}
					productId = newProductId					
					element = active.id
					element = {
						...element,
						id: productId
					}
					delete element.promoTileId;
					newElementFlag = true;
				}else{
					delete dynamicWithPromoted[productId]
				}
			}
			let sortedKeyArray = Object.entries(dynamicWithPromoted).sort((a, b) => Number(a[1]) - Number(b[1])).map(([key]) => key),
				currentDynamicItems = sortedKeyArray.indexOf(overProductId)
			if( productIndex === -1 ){
				for( let i = currentDynamicItems; i < sortedKeyArray.length; i++ ){
					let currentProductId = sortedKeyArray[i],
						updateCurrentPosition = 0;
					if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
						updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
						selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
					}else{
						updateCurrentPosition = dynamicItemsLocal[currentProductId] + 1
						dynamicItemsLocal[currentProductId] = updateCurrentPosition
					}
					if( typeof dynamicWithPromoted[sortedKeyArray[i+1]] !== "undefined" && dynamicWithPromoted[sortedKeyArray[i+1]] !== updateCurrentPosition ){
						break;
					}
				}
			}else if( currentDynamicItems < productIndex ){
				for( let i = currentDynamicItems; i < sortedKeyArray.length; i++ ){
					let currentProductId = sortedKeyArray[i],
						updateCurrentPosition = 0;
					if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
						updateCurrentPosition = selectedPromoTilesLocal[currentProductId] + 1
						selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
					}else{
						updateCurrentPosition = dynamicItemsLocal[currentProductId] + 1
						dynamicItemsLocal[currentProductId] = updateCurrentPosition
					}
					if( typeof dynamicWithPromoted[sortedKeyArray[i+1]] !== "undefined" && dynamicWithPromoted[sortedKeyArray[i+1]] !== updateCurrentPosition ){
						break;
					}
				}
			}else{
				for( let i = currentDynamicItems; i > productIndex; i-- ){
					let currentProductId = sortedKeyArray[i],
						updateCurrentPosition = 0;
					if( typeof selectedPromoTilesLocal[currentProductId] !== "undefined" ){
						updateCurrentPosition = selectedPromoTilesLocal[currentProductId] - 1
						selectedPromoTilesLocal[currentProductId] = updateCurrentPosition
					}else{
						updateCurrentPosition = dynamicItemsLocal[currentProductId] - 1
						dynamicItemsLocal[currentProductId] = updateCurrentPosition
					}
				}
			}
			if( active.id.isBanner ){
				selectedPromoTilesLocal[productId]	= newIndex
			}else{
				dynamicItemsLocal[productId]	= newIndex
			}
			productsLocal.splice(newIndex, 0, element)
			setSelectedPromoTiles(selectedPromoTilesLocal)
			setDynamicItems(dynamicItemsLocal)
			setProducts(productsLocal)
		}
	}

	if( pageLoader ){
		return <DetailSkeleton />
	}

	return (
		<div className="merchandisingCategoriesWrapper">
			<div className="headerNewWrapper">
				<div className="categoriesAddHeader">
					<button onClick={() => goBack()}>
						<FontAwesomeIcon icon={faAngleLeft} />
						<FontAwesomeIcon icon={faLayerGroup} />
						Search Merchandising - {state.type === "new" ? "New Rule" : (editSearchPhraseMerchandising ? editSearchPhraseMerchandising.searchPhrase : "")}
					</button>
				</div>
				<div className="merchandiseDetailHeaderRight">
					<div className="productGridContainer">
						<Dropdown isOpen={dropdownOpen} toggle={()=>toggleDropdown()} direction="down">
							<DropdownToggle caret>
								<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
									<g id="surface1">
										<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 2.519531 12.929688 C 2.570312 12.929688 2.625 12.929688 2.683594 12.929688 C 2.742188 12.929688 2.800781 12.929688 2.863281 12.929688 C 2.925781 12.929688 2.992188 12.929688 3.054688 12.929688 C 3.265625 12.925781 3.472656 12.925781 3.683594 12.925781 C 3.753906 12.925781 3.828125 12.925781 3.898438 12.925781 C 4.238281 12.925781 4.578125 12.925781 4.917969 12.921875 C 5.308594 12.921875 5.699219 12.921875 6.089844 12.921875 C 6.390625 12.917969 6.695312 12.917969 6.996094 12.917969 C 7.175781 12.917969 7.359375 12.917969 7.539062 12.917969 C 7.707031 12.914062 7.878906 12.914062 8.046875 12.914062 C 8.140625 12.914062 8.230469 12.914062 8.324219 12.914062 C 9.054688 12.917969 9.730469 13.179688 10.269531 13.683594 C 10.710938 14.167969 11.066406 14.785156 11.070312 15.457031 C 11.070312 15.535156 11.070312 15.535156 11.070312 15.621094 C 11.070312 15.679688 11.070312 15.738281 11.070312 15.800781 C 11.070312 15.863281 11.070312 15.929688 11.070312 15.992188 C 11.074219 16.203125 11.074219 16.410156 11.074219 16.621094 C 11.074219 16.691406 11.074219 16.765625 11.074219 16.835938 C 11.074219 17.175781 11.074219 17.515625 11.078125 17.855469 C 11.078125 18.246094 11.078125 18.636719 11.078125 19.027344 C 11.082031 19.328125 11.082031 19.632812 11.082031 19.933594 C 11.082031 20.113281 11.082031 20.296875 11.082031 20.476562 C 11.085938 20.644531 11.085938 20.816406 11.085938 20.984375 C 11.085938 21.078125 11.085938 21.167969 11.085938 21.261719 C 11.082031 21.992188 10.820312 22.667969 10.320312 23.207031 C 9.832031 23.648438 9.214844 24.003906 8.542969 24.007812 C 8.492188 24.007812 8.4375 24.007812 8.378906 24.007812 C 8.320312 24.007812 8.261719 24.007812 8.199219 24.007812 C 8.136719 24.007812 8.070312 24.007812 8.007812 24.007812 C 7.796875 24.011719 7.589844 24.011719 7.378906 24.011719 C 7.308594 24.011719 7.234375 24.011719 7.164062 24.011719 C 6.824219 24.011719 6.484375 24.011719 6.144531 24.015625 C 5.753906 24.015625 5.363281 24.015625 4.972656 24.015625 C 4.671875 24.019531 4.367188 24.019531 4.066406 24.019531 C 3.886719 24.019531 3.703125 24.019531 3.523438 24.019531 C 3.355469 24.023438 3.183594 24.023438 3.015625 24.023438 C 2.921875 24.023438 2.832031 24.023438 2.738281 24.023438 C 2.007812 24.019531 1.332031 23.757812 0.792969 23.257812 C 0.351562 22.769531 -0.00390625 22.152344 -0.0078125 21.480469 C -0.0078125 21.429688 -0.0078125 21.375 -0.0078125 21.316406 C -0.0078125 21.257812 -0.0078125 21.199219 -0.0078125 21.136719 C -0.0078125 21.074219 -0.0078125 21.007812 -0.0078125 20.945312 C -0.0117188 20.734375 -0.0117188 20.527344 -0.0117188 20.316406 C -0.0117188 20.246094 -0.0117188 20.171875 -0.0117188 20.101562 C -0.0117188 19.761719 -0.0117188 19.421875 -0.015625 19.082031 C -0.015625 18.691406 -0.015625 18.300781 -0.015625 17.910156 C -0.0195312 17.609375 -0.0195312 17.304688 -0.0195312 17.003906 C -0.0195312 16.824219 -0.0195312 16.640625 -0.0195312 16.460938 C -0.0234375 16.292969 -0.0234375 16.121094 -0.0234375 15.953125 C -0.0234375 15.859375 -0.0234375 15.769531 -0.0234375 15.675781 C -0.0195312 14.945312 0.242188 14.269531 0.746094 13.730469 C 1.230469 13.289062 1.847656 12.933594 2.519531 12.929688 Z M 2.183594 15.035156 C 2.160156 15.066406 2.132812 15.09375 2.109375 15.125 C 2.085938 15.15625 2.058594 15.183594 2.035156 15.214844 C 1.851562 15.535156 1.859375 15.886719 1.863281 16.246094 C 1.863281 16.300781 1.863281 16.351562 1.863281 16.40625 C 1.859375 16.582031 1.859375 16.757812 1.859375 16.933594 C 1.859375 17.054688 1.859375 17.179688 1.859375 17.300781 C 1.859375 17.554688 1.859375 17.8125 1.859375 18.070312 C 1.859375 18.363281 1.859375 18.660156 1.859375 18.953125 C 1.859375 19.238281 1.859375 19.523438 1.859375 19.808594 C 1.859375 19.929688 1.859375 20.050781 1.855469 20.171875 C 1.855469 20.339844 1.855469 20.511719 1.859375 20.679688 C 1.855469 20.730469 1.855469 20.777344 1.855469 20.828125 C 1.859375 21.175781 1.890625 21.527344 2.097656 21.816406 C 2.128906 21.839844 2.15625 21.867188 2.1875 21.890625 C 2.21875 21.914062 2.246094 21.941406 2.277344 21.96875 C 2.597656 22.148438 2.949219 22.140625 3.308594 22.136719 C 3.386719 22.136719 3.386719 22.136719 3.46875 22.136719 C 3.644531 22.140625 3.820312 22.140625 3.996094 22.140625 C 4.117188 22.140625 4.242188 22.140625 4.363281 22.140625 C 4.617188 22.140625 4.875 22.140625 5.132812 22.140625 C 5.425781 22.140625 5.722656 22.140625 6.015625 22.140625 C 6.300781 22.140625 6.585938 22.140625 6.871094 22.140625 C 6.992188 22.140625 7.113281 22.140625 7.234375 22.144531 C 7.402344 22.144531 7.574219 22.144531 7.742188 22.140625 C 7.792969 22.144531 7.839844 22.144531 7.890625 22.144531 C 8.238281 22.140625 8.589844 22.109375 8.878906 21.902344 C 8.902344 21.871094 8.929688 21.84375 8.953125 21.8125 C 8.976562 21.78125 9.003906 21.753906 9.03125 21.722656 C 9.210938 21.402344 9.203125 21.050781 9.199219 20.691406 C 9.199219 20.636719 9.199219 20.585938 9.199219 20.53125 C 9.203125 20.355469 9.203125 20.179688 9.203125 20.003906 C 9.203125 19.882812 9.203125 19.757812 9.203125 19.636719 C 9.203125 19.382812 9.203125 19.125 9.203125 18.867188 C 9.203125 18.574219 9.203125 18.277344 9.203125 17.984375 C 9.203125 17.699219 9.203125 17.414062 9.203125 17.128906 C 9.203125 17.007812 9.203125 16.886719 9.207031 16.765625 C 9.207031 16.597656 9.207031 16.425781 9.203125 16.257812 C 9.207031 16.207031 9.207031 16.160156 9.207031 16.109375 C 9.203125 15.761719 9.171875 15.410156 8.964844 15.121094 C 8.933594 15.097656 8.90625 15.070312 8.875 15.046875 C 8.832031 15.007812 8.832031 15.007812 8.785156 14.972656 C 8.464844 14.789062 8.113281 14.796875 7.753906 14.800781 C 7.699219 14.800781 7.648438 14.800781 7.59375 14.800781 C 7.417969 14.796875 7.242188 14.796875 7.066406 14.796875 C 6.945312 14.796875 6.820312 14.796875 6.699219 14.796875 C 6.445312 14.796875 6.1875 14.796875 5.929688 14.796875 C 5.636719 14.796875 5.339844 14.796875 5.046875 14.796875 C 4.761719 14.796875 4.476562 14.796875 4.191406 14.796875 C 4.070312 14.796875 3.949219 14.796875 3.828125 14.792969 C 3.660156 14.792969 3.488281 14.792969 3.320312 14.796875 C 3.246094 14.792969 3.246094 14.792969 3.171875 14.792969 C 2.824219 14.796875 2.472656 14.828125 2.183594 15.035156 Z M 2.183594 15.035156 " />
										<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 2.519531 -0.0078125 C 2.570312 -0.0078125 2.625 -0.0078125 2.683594 -0.0078125 C 2.742188 -0.0078125 2.800781 -0.0078125 2.863281 -0.0078125 C 2.925781 -0.0078125 2.992188 -0.0078125 3.054688 -0.0078125 C 3.265625 -0.0117188 3.472656 -0.0117188 3.683594 -0.0117188 C 3.753906 -0.0117188 3.828125 -0.0117188 3.898438 -0.0117188 C 4.238281 -0.0117188 4.578125 -0.0117188 4.917969 -0.015625 C 5.308594 -0.015625 5.699219 -0.015625 6.089844 -0.015625 C 6.390625 -0.0195312 6.695312 -0.0195312 6.996094 -0.0195312 C 7.175781 -0.0195312 7.359375 -0.0195312 7.539062 -0.0195312 C 7.707031 -0.0234375 7.878906 -0.0234375 8.046875 -0.0234375 C 8.140625 -0.0234375 8.230469 -0.0234375 8.324219 -0.0234375 C 9.054688 -0.0195312 9.730469 0.242188 10.269531 0.742188 C 10.710938 1.230469 11.066406 1.847656 11.070312 2.519531 C 11.070312 2.597656 11.070312 2.597656 11.070312 2.683594 C 11.070312 2.742188 11.070312 2.800781 11.070312 2.863281 C 11.070312 2.925781 11.070312 2.992188 11.070312 3.054688 C 11.074219 3.265625 11.074219 3.472656 11.074219 3.683594 C 11.074219 3.753906 11.074219 3.828125 11.074219 3.898438 C 11.074219 4.238281 11.074219 4.578125 11.078125 4.917969 C 11.078125 5.308594 11.078125 5.699219 11.078125 6.089844 C 11.082031 6.390625 11.082031 6.695312 11.082031 6.996094 C 11.082031 7.175781 11.082031 7.359375 11.082031 7.539062 C 11.085938 7.707031 11.085938 7.878906 11.085938 8.046875 C 11.085938 8.140625 11.085938 8.230469 11.085938 8.324219 C 11.082031 9.054688 10.820312 9.730469 10.320312 10.269531 C 9.832031 10.710938 9.214844 11.066406 8.542969 11.070312 C 8.492188 11.070312 8.4375 11.070312 8.378906 11.070312 C 8.320312 11.070312 8.261719 11.070312 8.199219 11.070312 C 8.136719 11.070312 8.070312 11.070312 8.007812 11.070312 C 7.796875 11.074219 7.589844 11.074219 7.378906 11.074219 C 7.308594 11.074219 7.234375 11.074219 7.164062 11.074219 C 6.824219 11.074219 6.484375 11.074219 6.144531 11.078125 C 5.753906 11.078125 5.363281 11.078125 4.972656 11.078125 C 4.671875 11.082031 4.367188 11.082031 4.066406 11.082031 C 3.886719 11.082031 3.703125 11.082031 3.523438 11.082031 C 3.355469 11.085938 3.183594 11.085938 3.015625 11.085938 C 2.921875 11.085938 2.832031 11.085938 2.738281 11.085938 C 2.007812 11.082031 1.332031 10.820312 0.792969 10.316406 C 0.351562 9.832031 -0.00390625 9.214844 -0.0078125 8.542969 C -0.0078125 8.492188 -0.0078125 8.4375 -0.0078125 8.378906 C -0.0078125 8.320312 -0.0078125 8.261719 -0.0078125 8.199219 C -0.0078125 8.136719 -0.0078125 8.070312 -0.0078125 8.007812 C -0.0117188 7.796875 -0.0117188 7.589844 -0.0117188 7.378906 C -0.0117188 7.308594 -0.0117188 7.234375 -0.0117188 7.164062 C -0.0117188 6.824219 -0.0117188 6.484375 -0.015625 6.144531 C -0.015625 5.753906 -0.015625 5.363281 -0.015625 4.972656 C -0.0195312 4.671875 -0.0195312 4.367188 -0.0195312 4.066406 C -0.0195312 3.886719 -0.0195312 3.703125 -0.0195312 3.523438 C -0.0234375 3.355469 -0.0234375 3.183594 -0.0234375 3.015625 C -0.0234375 2.921875 -0.0234375 2.832031 -0.0234375 2.738281 C -0.0195312 2.007812 0.242188 1.332031 0.746094 0.792969 C 1.230469 0.351562 1.847656 -0.00390625 2.519531 -0.0078125 Z M 2.183594 2.097656 C 2.160156 2.128906 2.132812 2.15625 2.109375 2.1875 C 2.085938 2.21875 2.058594 2.246094 2.035156 2.277344 C 1.851562 2.597656 1.859375 2.949219 1.863281 3.308594 C 1.863281 3.363281 1.863281 3.414062 1.863281 3.46875 C 1.859375 3.644531 1.859375 3.820312 1.859375 3.996094 C 1.859375 4.117188 1.859375 4.242188 1.859375 4.363281 C 1.859375 4.617188 1.859375 4.875 1.859375 5.132812 C 1.859375 5.425781 1.859375 5.722656 1.859375 6.015625 C 1.859375 6.300781 1.859375 6.585938 1.859375 6.871094 C 1.859375 6.992188 1.859375 7.113281 1.855469 7.234375 C 1.855469 7.402344 1.855469 7.574219 1.859375 7.742188 C 1.855469 7.792969 1.855469 7.839844 1.855469 7.890625 C 1.859375 8.238281 1.890625 8.589844 2.097656 8.878906 C 2.128906 8.902344 2.15625 8.929688 2.1875 8.953125 C 2.21875 8.976562 2.246094 9.003906 2.277344 9.027344 C 2.597656 9.210938 2.949219 9.203125 3.308594 9.199219 C 3.386719 9.199219 3.386719 9.199219 3.46875 9.199219 C 3.644531 9.203125 3.820312 9.203125 3.996094 9.203125 C 4.117188 9.203125 4.242188 9.203125 4.363281 9.203125 C 4.617188 9.203125 4.875 9.203125 5.132812 9.203125 C 5.425781 9.203125 5.722656 9.203125 6.015625 9.203125 C 6.300781 9.203125 6.585938 9.203125 6.871094 9.203125 C 6.992188 9.203125 7.113281 9.203125 7.234375 9.207031 C 7.402344 9.207031 7.574219 9.207031 7.742188 9.203125 C 7.792969 9.207031 7.839844 9.207031 7.890625 9.207031 C 8.238281 9.203125 8.589844 9.171875 8.878906 8.964844 C 8.902344 8.933594 8.929688 8.90625 8.953125 8.875 C 8.976562 8.84375 9.003906 8.816406 9.03125 8.785156 C 9.210938 8.464844 9.203125 8.113281 9.199219 7.753906 C 9.199219 7.699219 9.199219 7.648438 9.199219 7.59375 C 9.203125 7.417969 9.203125 7.242188 9.203125 7.066406 C 9.203125 6.945312 9.203125 6.820312 9.203125 6.699219 C 9.203125 6.445312 9.203125 6.1875 9.203125 5.929688 C 9.203125 5.636719 9.203125 5.339844 9.203125 5.046875 C 9.203125 4.761719 9.203125 4.476562 9.203125 4.191406 C 9.203125 4.070312 9.203125 3.949219 9.207031 3.828125 C 9.207031 3.660156 9.207031 3.488281 9.203125 3.320312 C 9.207031 3.269531 9.207031 3.222656 9.207031 3.171875 C 9.203125 2.824219 9.171875 2.472656 8.964844 2.183594 C 8.933594 2.160156 8.90625 2.132812 8.875 2.109375 C 8.832031 2.070312 8.832031 2.070312 8.785156 2.03125 C 8.464844 1.851562 8.113281 1.859375 7.753906 1.863281 C 7.699219 1.863281 7.648438 1.863281 7.59375 1.863281 C 7.417969 1.859375 7.242188 1.859375 7.066406 1.859375 C 6.945312 1.859375 6.820312 1.859375 6.699219 1.859375 C 6.445312 1.859375 6.1875 1.859375 5.929688 1.859375 C 5.636719 1.859375 5.339844 1.859375 5.046875 1.859375 C 4.761719 1.859375 4.476562 1.859375 4.191406 1.859375 C 4.070312 1.859375 3.949219 1.859375 3.828125 1.855469 C 3.660156 1.855469 3.488281 1.855469 3.320312 1.859375 C 3.246094 1.855469 3.246094 1.855469 3.171875 1.855469 C 2.824219 1.859375 2.472656 1.890625 2.183594 2.097656 Z M 2.183594 2.097656 " />
										<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 15.859375 12.925781 C 15.925781 12.921875 15.988281 12.921875 16.050781 12.921875 C 16.21875 12.921875 16.390625 12.921875 16.558594 12.921875 C 16.664062 12.921875 16.769531 12.921875 16.878906 12.921875 C 17.25 12.921875 17.621094 12.921875 17.992188 12.921875 C 18.339844 12.921875 18.683594 12.917969 19.027344 12.917969 C 19.324219 12.917969 19.625 12.914062 19.921875 12.917969 C 20.097656 12.917969 20.273438 12.914062 20.453125 12.914062 C 20.617188 12.914062 20.785156 12.914062 20.953125 12.914062 C 21.042969 12.914062 21.132812 12.914062 21.222656 12.914062 C 21.980469 12.917969 22.640625 13.195312 23.191406 13.71875 C 23.789062 14.335938 24.015625 15.015625 24.011719 15.859375 C 24.015625 15.925781 24.015625 15.988281 24.015625 16.050781 C 24.015625 16.21875 24.015625 16.390625 24.015625 16.558594 C 24.015625 16.664062 24.015625 16.769531 24.015625 16.878906 C 24.015625 17.25 24.015625 17.621094 24.015625 17.992188 C 24.015625 18.339844 24.019531 18.683594 24.019531 19.027344 C 24.019531 19.324219 24.023438 19.625 24.019531 19.921875 C 24.019531 20.097656 24.023438 20.273438 24.023438 20.453125 C 24.023438 20.617188 24.023438 20.785156 24.023438 20.953125 C 24.023438 21.042969 24.023438 21.132812 24.023438 21.222656 C 24.019531 21.980469 23.742188 22.640625 23.21875 23.191406 C 22.601562 23.789062 21.921875 24.015625 21.078125 24.011719 C 21.011719 24.015625 20.949219 24.015625 20.886719 24.015625 C 20.71875 24.015625 20.546875 24.015625 20.378906 24.015625 C 20.273438 24.015625 20.167969 24.015625 20.058594 24.015625 C 19.6875 24.015625 19.316406 24.015625 18.945312 24.015625 C 18.597656 24.015625 18.253906 24.019531 17.910156 24.019531 C 17.613281 24.019531 17.3125 24.023438 17.015625 24.019531 C 16.839844 24.019531 16.664062 24.023438 16.484375 24.023438 C 16.320312 24.023438 16.152344 24.023438 15.984375 24.023438 C 15.894531 24.023438 15.804688 24.023438 15.714844 24.023438 C 14.957031 24.019531 14.296875 23.742188 13.746094 23.21875 C 13.148438 22.601562 12.921875 21.921875 12.925781 21.078125 C 12.921875 21.011719 12.921875 20.949219 12.921875 20.886719 C 12.921875 20.71875 12.921875 20.546875 12.921875 20.378906 C 12.921875 20.273438 12.921875 20.167969 12.921875 20.058594 C 12.921875 19.6875 12.921875 19.316406 12.921875 18.945312 C 12.921875 18.597656 12.917969 18.253906 12.917969 17.910156 C 12.917969 17.613281 12.914062 17.3125 12.917969 17.015625 C 12.917969 16.839844 12.914062 16.664062 12.914062 16.484375 C 12.914062 16.320312 12.914062 16.152344 12.914062 15.984375 C 12.914062 15.894531 12.914062 15.804688 12.914062 15.714844 C 12.917969 14.957031 13.195312 14.296875 13.71875 13.746094 C 14.335938 13.148438 15.015625 12.921875 15.859375 12.925781 Z M 15.046875 15.140625 C 14.785156 15.484375 14.804688 15.863281 14.804688 16.273438 C 14.804688 16.328125 14.804688 16.378906 14.804688 16.433594 C 14.804688 16.605469 14.804688 16.78125 14.804688 16.953125 C 14.804688 17.074219 14.804688 17.195312 14.804688 17.316406 C 14.804688 17.566406 14.804688 17.820312 14.804688 18.074219 C 14.804688 18.363281 14.804688 18.65625 14.800781 18.949219 C 14.800781 19.230469 14.800781 19.511719 14.800781 19.792969 C 14.800781 19.910156 14.800781 20.03125 14.800781 20.148438 C 14.800781 20.316406 14.800781 20.484375 14.800781 20.648438 C 14.800781 20.699219 14.800781 20.75 14.800781 20.800781 C 14.800781 21.210938 14.84375 21.582031 15.140625 21.890625 C 15.484375 22.152344 15.863281 22.132812 16.273438 22.132812 C 16.328125 22.132812 16.378906 22.132812 16.433594 22.132812 C 16.605469 22.132812 16.78125 22.132812 16.953125 22.132812 C 17.074219 22.132812 17.195312 22.132812 17.316406 22.132812 C 17.566406 22.132812 17.820312 22.132812 18.074219 22.132812 C 18.363281 22.132812 18.65625 22.132812 18.949219 22.136719 C 19.230469 22.136719 19.511719 22.136719 19.792969 22.136719 C 19.910156 22.136719 20.03125 22.136719 20.148438 22.136719 C 20.316406 22.136719 20.484375 22.136719 20.648438 22.136719 C 20.699219 22.136719 20.75 22.136719 20.800781 22.136719 C 21.210938 22.136719 21.582031 22.09375 21.890625 21.796875 C 22.152344 21.453125 22.132812 21.074219 22.132812 20.664062 C 22.132812 20.609375 22.132812 20.558594 22.132812 20.503906 C 22.132812 20.332031 22.132812 20.15625 22.132812 19.984375 C 22.132812 19.863281 22.132812 19.742188 22.132812 19.621094 C 22.132812 19.371094 22.132812 19.117188 22.132812 18.863281 C 22.132812 18.574219 22.132812 18.28125 22.136719 17.988281 C 22.136719 17.707031 22.136719 17.425781 22.136719 17.144531 C 22.136719 17.027344 22.136719 16.90625 22.136719 16.789062 C 22.136719 16.621094 22.136719 16.453125 22.136719 16.289062 C 22.136719 16.238281 22.136719 16.1875 22.136719 16.136719 C 22.136719 15.726562 22.09375 15.355469 21.796875 15.046875 C 21.453125 14.785156 21.074219 14.804688 20.664062 14.804688 C 20.609375 14.804688 20.558594 14.804688 20.503906 14.804688 C 20.332031 14.804688 20.15625 14.804688 19.984375 14.804688 C 19.863281 14.804688 19.742188 14.804688 19.621094 14.804688 C 19.371094 14.804688 19.117188 14.804688 18.863281 14.804688 C 18.574219 14.804688 18.28125 14.804688 17.988281 14.800781 C 17.707031 14.800781 17.425781 14.800781 17.144531 14.800781 C 17.027344 14.800781 16.90625 14.800781 16.789062 14.800781 C 16.621094 14.800781 16.453125 14.800781 16.289062 14.800781 C 16.238281 14.800781 16.1875 14.800781 16.136719 14.800781 C 15.726562 14.800781 15.355469 14.84375 15.046875 15.140625 Z M 15.046875 15.140625 " />
										<path style={{ stroke: "none", fillRule: "nonzero", fill: "currentcolor", fillOpacity: 1 }} d="M 15.859375 -0.0117188 C 15.925781 -0.015625 15.988281 -0.015625 16.050781 -0.015625 C 16.21875 -0.015625 16.390625 -0.015625 16.558594 -0.015625 C 16.664062 -0.015625 16.769531 -0.015625 16.878906 -0.015625 C 17.25 -0.015625 17.621094 -0.015625 17.992188 -0.015625 C 18.339844 -0.015625 18.683594 -0.0195312 19.027344 -0.0195312 C 19.324219 -0.0195312 19.625 -0.0234375 19.921875 -0.0195312 C 20.097656 -0.0195312 20.273438 -0.0234375 20.453125 -0.0234375 C 20.617188 -0.0234375 20.785156 -0.0234375 20.953125 -0.0234375 C 21.042969 -0.0234375 21.132812 -0.0234375 21.222656 -0.0234375 C 21.980469 -0.0195312 22.640625 0.257812 23.191406 0.78125 C 23.789062 1.398438 24.015625 2.078125 24.011719 2.921875 C 24.015625 2.988281 24.015625 3.050781 24.015625 3.113281 C 24.015625 3.28125 24.015625 3.453125 24.015625 3.621094 C 24.015625 3.726562 24.015625 3.832031 24.015625 3.941406 C 24.015625 4.3125 24.015625 4.683594 24.015625 5.054688 C 24.015625 5.402344 24.019531 5.746094 24.019531 6.089844 C 24.019531 6.386719 24.023438 6.6875 24.019531 6.984375 C 24.019531 7.160156 24.023438 7.335938 24.023438 7.515625 C 24.023438 7.679688 24.023438 7.847656 24.023438 8.015625 C 24.023438 8.105469 24.023438 8.195312 24.023438 8.285156 C 24.019531 9.042969 23.742188 9.703125 23.21875 10.253906 C 22.601562 10.851562 21.921875 11.078125 21.078125 11.074219 C 21.011719 11.078125 20.949219 11.078125 20.886719 11.078125 C 20.71875 11.078125 20.546875 11.078125 20.378906 11.078125 C 20.273438 11.078125 20.167969 11.078125 20.058594 11.078125 C 19.6875 11.078125 19.316406 11.078125 18.945312 11.078125 C 18.597656 11.078125 18.253906 11.082031 17.910156 11.082031 C 17.613281 11.082031 17.3125 11.085938 17.015625 11.082031 C 16.839844 11.082031 16.664062 11.085938 16.484375 11.085938 C 16.320312 11.085938 16.152344 11.085938 15.984375 11.085938 C 15.894531 11.085938 15.804688 11.085938 15.714844 11.085938 C 14.957031 11.082031 14.296875 10.804688 13.746094 10.28125 C 13.148438 9.664062 12.921875 8.984375 12.925781 8.140625 C 12.921875 8.074219 12.921875 8.011719 12.921875 7.949219 C 12.921875 7.78125 12.921875 7.609375 12.921875 7.441406 C 12.921875 7.335938 12.921875 7.230469 12.921875 7.121094 C 12.921875 6.75 12.921875 6.378906 12.921875 6.007812 C 12.921875 5.660156 12.917969 5.316406 12.917969 4.972656 C 12.917969 4.675781 12.914062 4.375 12.917969 4.078125 C 12.917969 3.902344 12.914062 3.726562 12.914062 3.546875 C 12.914062 3.382812 12.914062 3.214844 12.914062 3.046875 C 12.914062 2.957031 12.914062 2.867188 12.914062 2.777344 C 12.917969 2.019531 13.195312 1.359375 13.71875 0.808594 C 14.335938 0.210938 15.015625 -0.015625 15.859375 -0.0117188 Z M 15.046875 2.203125 C 14.785156 2.546875 14.804688 2.925781 14.804688 3.335938 C 14.804688 3.390625 14.804688 3.441406 14.804688 3.496094 C 14.804688 3.667969 14.804688 3.84375 14.804688 4.015625 C 14.804688 4.136719 14.804688 4.257812 14.804688 4.378906 C 14.804688 4.628906 14.804688 4.882812 14.804688 5.136719 C 14.804688 5.425781 14.804688 5.71875 14.800781 6.011719 C 14.800781 6.292969 14.800781 6.574219 14.800781 6.855469 C 14.800781 6.972656 14.800781 7.09375 14.800781 7.210938 C 14.800781 7.378906 14.800781 7.546875 14.800781 7.710938 C 14.800781 7.761719 14.800781 7.8125 14.800781 7.863281 C 14.800781 8.273438 14.84375 8.644531 15.140625 8.953125 C 15.484375 9.214844 15.863281 9.195312 16.273438 9.195312 C 16.328125 9.195312 16.378906 9.195312 16.433594 9.195312 C 16.605469 9.195312 16.78125 9.195312 16.953125 9.195312 C 17.074219 9.195312 17.195312 9.195312 17.316406 9.195312 C 17.566406 9.195312 17.820312 9.195312 18.074219 9.195312 C 18.363281 9.195312 18.65625 9.195312 18.949219 9.199219 C 19.230469 9.199219 19.511719 9.199219 19.792969 9.199219 C 19.910156 9.199219 20.03125 9.199219 20.148438 9.199219 C 20.316406 9.199219 20.484375 9.199219 20.648438 9.199219 C 20.699219 9.199219 20.75 9.199219 20.800781 9.199219 C 21.210938 9.199219 21.582031 9.15625 21.890625 8.859375 C 22.152344 8.515625 22.132812 8.136719 22.132812 7.726562 C 22.132812 7.671875 22.132812 7.621094 22.132812 7.566406 C 22.132812 7.394531 22.132812 7.21875 22.132812 7.046875 C 22.132812 6.925781 22.132812 6.804688 22.132812 6.683594 C 22.132812 6.433594 22.132812 6.179688 22.132812 5.925781 C 22.132812 5.636719 22.132812 5.34375 22.136719 5.050781 C 22.136719 4.769531 22.136719 4.488281 22.136719 4.207031 C 22.136719 4.089844 22.136719 3.96875 22.136719 3.851562 C 22.136719 3.683594 22.136719 3.515625 22.136719 3.351562 C 22.136719 3.300781 22.136719 3.25 22.136719 3.199219 C 22.136719 2.789062 22.09375 2.417969 21.796875 2.109375 C 21.453125 1.847656 21.074219 1.867188 20.664062 1.867188 C 20.609375 1.867188 20.558594 1.867188 20.503906 1.867188 C 20.332031 1.867188 20.15625 1.867188 19.984375 1.867188 C 19.863281 1.867188 19.742188 1.867188 19.621094 1.867188 C 19.371094 1.867188 19.117188 1.867188 18.863281 1.867188 C 18.574219 1.867188 18.28125 1.867188 17.988281 1.863281 C 17.707031 1.863281 17.425781 1.863281 17.144531 1.863281 C 17.027344 1.863281 16.90625 1.863281 16.789062 1.863281 C 16.621094 1.863281 16.453125 1.863281 16.289062 1.863281 C 16.238281 1.863281 16.1875 1.863281 16.136719 1.863281 C 15.726562 1.863281 15.355469 1.90625 15.046875 2.203125 Z M 15.046875 2.203125 " />
									</g>
								</svg>
							</DropdownToggle>
							<DropdownMenu>
								{items.map((item) => (
									<DropdownItem key={item.value} onClick={() => setRowPerProducts(item.value)}>
										{item.content}
									</DropdownItem>
								))}
							</DropdownMenu>
						</Dropdown>
					</div>
					<div className="saveSelectContainer">
						{((hidden.length === 0 && Object.keys(pinnedItems).length === 0 && Object.keys(selectedPromoTiles).length === 0 && Object.keys(dynamicItems).length === 0) || !enableSave) &&
							<FontAwesomeIcon icon={faExclamationCircle} size='1x' />
						}
						{saveLoader ?
							<Spinner size={"sm"} />
							:
							<span className={`saveBtnTxtWrap ${(((hidden.length === 0 && Object.keys(pinnedItems).length === 0 && Object.keys(selectedPromoTiles).length === 0 && Object.keys(dynamicItems).length === 0) || !enableSave) || saveLoader) ? "disabled" : ""}`} onClick={() => saveSearchMerchandising()}>
								Save
							</span>
						}
					</div>
				</div>
			</div>
			<div className="contentWrapper">
				<DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd} onDragStart={handleDragStart}>
					<div className="merchandisingGridContainer">
						<SidebarNavigation />
						<div className="sidebarMenuContainer">
							{activeMenu === "general" ?
								<GeneralSearch type={state.type} />
								: activeMenu === "buried" ?
									<BuriedProducts />
									: activeMenu === "banner" ?
										<Banners />
										: activeMenu === "promoTile" ?
											<PromoTiles />
											: activeMenu === "hidden" ?
												<HiddenProducts />
												: activeMenu === "dynamic" &&
												<Dynamic type={state.type} />
							}
						</div>
						<div className="sidebarContentContainer">
							<div className="sidebarInnerContent">
								<ProductListing type="search" />
							</div>
						</div>
					</div>
					<DragOverlay>
						{activeItem ? (
							<div
								style={{
									// padding: "10px",
									// backgroundColor: "white",
									// border: "1px solid gray",
									// borderRadius: "4px",
									// boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
									cursor: "grabbing",
								}}
								className='dragOverlay'
							>
								{!activeItem.isBanner ?
									<div product-id={activeItem.id} className='mainProductContainer' style={{ display: "flex", position: "relative", width: "100%", height: "100%" }}>
										<div id={activeItem.id} className='selectableProductCard' style={{ width: "100%", height: "100%" }}>
											<div className='productCard'>
												<div className='imageAndActionContainer'>
													<div className='productLableContainer'>
														<div className='badgeContainer'>
															{promoted.indexOf(activeItem.id) !== -1 ?
																<div className="badgeLabelTextWrap" style={{ backgroundColor: "rgb(0, 136, 71)", color: "white" }}>Promoted</div>
																: buried.indexOf(activeItem.id) !== -1 ?
																	<div className="badgeLabelTextWrap" style={{ backgroundColor: "rgb(234, 12, 25)", color: "white" }}>Buried</div>
																	: typeof pinnedItems[activeItem.id] !== "undefined" ?
																		<div className="badgeLabelTextWrap" style={{ backgroundColor: "rgb(0, 147, 229)", color: "white" }}>Pinned</div>
																		: typeof dynamicItems[activeItem.id] !== "undefined" &&
																		<div className="badgeLabelTextWrap" style={{ backgroundColor: "rgb(16, 78, 111)", color: "white" }}>AI</div>
															}
														</div>
														{/* <div className='productPosition'></div> */}
													</div>
													<div className='imageWrapper'>
														<img src={activeItem.image ? activeItem.image : "https://storage.googleapis.com/roundclicksview/No%20Product%20Image%20Available.png"} alt={activeItem.title} title={activeItem.title} />
													</div>
												</div>
												<div className='productInfoContainer'>
													<div className='productTitleWrapper'>
														{activeItem.title}
													</div>
													<div className='productSkuWrapper'>{activeItem.sku}</div>
													<div className='productCardFooter'>
														<div className='productPriceContainer'>
															{formatPrice(activeItem)}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									:
									<div product-id={"promoTile_" + activeItem.id} className='promoTileOuterContainer' style={{ width: "100%", height: "100%" }}>
										<div id={activeItem.id} className='promoTileInnerContainer'>
											<div className='promoTileContainer' style={{ height: "200px" }}>
												<div className="promoTileImageContainer">
													<img src={activeItem.image} alt={activeItem.title} className="promoTileImage" />
													<div className="promoTileTitleContainer">{activeItem.title}</div>
													<div className='promoTileSizeWrapper'>{activeItem.bannerSize}</div>
												</div>
											</div>
										</div>
									</div>
								}
							</div>
						) : null}
					</DragOverlay>
				</DndContext>
			</div>
		</div>
	)
};

export default EditSearch;